module.exports = __webpack_public_path__ + "static/img/performance02.f239f3ec.jpg";